import { axiosSwagger } from "@/axios";

export const state = {
    postPoolFolder: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    loading: (state, loading) => {
        state.postPoolFolder.loading = loading;
    },
    setData: (state, data) => {
        state.postPoolFolder.data = modifyData( data );
    },
    setTotal: (state, total) => {
        state.postPoolFolder.total = total;
    },
    remove: (state, id) => {
        state.postPoolFolder.data = state.postPoolFolder.data.filter((el) => el.id !== id);
    },
    removeMultiple: (state, dataArr) => {
        state.postPoolFolder.data = state.postPoolFolder.data.filter(
            (el) => !dataArr?.includes(el.id)
        );
    },
}


export const actions = {
  // POST POOL FOLDER
  async readPostPoolFolderByPostPoolId({ commit }, id) {
    commit("loading", true);

    return await axiosSwagger
    .get(`/api/PostPoolFolder/PostPool/${id}`)
    .then((response) => {
      commit("setData", response.data);
      commit("setTotal", response.data.length);
      commit("loading", false);

      return response;
    })
    .catch(() => {
        commit("loading", false);
    });
  },
  // eslint-disable-next-line no-unused-vars
  async createBulkPostPoolFolders({ commit }, data) {
    return await axiosSwagger
    .post(`/api/PostPoolFolder/Add`, data)
    .then((response) => {
      return response;
    });
  },
  async deletePostPoolFolder({ commit }, id) {
    return await axiosSwagger
    .delete(`/api/PostPoolFolder/${id}`)
    .then((response) => {
      commit("remove", id);
      return response;
    });
  },
  // eslint-disable-next-line no-unused-vars
  async deleteMultiplePostPoolFolder({ commit }, id) {
    return await axiosSwagger
    .delete(`/api/PostPoolFolder/${id}`)
    .then((response) => {
      return response;
    });
  },
  // eslint-disable-next-line no-unused-vars
  async deleteBulkPostPoolFolders({ commit }, fileFolderIds) {
    return await axiosSwagger
    .post(`/api/PostPoolFolder/Remove`, fileFolderIds)
    .then((response) => {
      return response;
    });
  },
  async readFolderDetailsById({ commit }, id) {
    commit("loading", true);

    return await axiosSwagger
    .get(`/api/FileFolder/Details/${id}`)
    .then((response) => {
      commit("loading", false);
      return response;
    })
    .catch(() => {
      commit("loading", false);
    });
  },
}


// modify data to add origId for tracking the original id of the post pool file, since when we create a new post pool file, we set its id to null and update it after we get the response from the server, this is to prevent the issue of having multiple post pool files with the same id in the state before we get the response from the server and update the id.
const modifyData = (arrayData) => {
  if(arrayData?.length ?? false){
    arrayData.forEach(e => {
      e.fileFolder.origId = e?.id || 0;
    });

    
    return arrayData
  }

  return [];
};